import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import * as S from './styles';
import images from '~/constants/images';
import { Link, Icon } from '~/components';

const NotFoundBig = () => (
  <>
    4<Icon name="footballEvent" size={55} color="dark" />4
  </>
);

export default function NotFound({ type = 'not-found' }) {
  const { t } = useTranslation();

  const content = {
    'not-found': {
      big: <NotFoundBig />,
      title: t('offside'),
      message: t('checkUrl'),
    },
    uncaught: {
      big: t('OOPS'),
      title: t('offside'),
      message: t('uncaughtError'),
    },
  };

  return (
    <S.Container>
      <S.Background />
      <S.BeatDecoration />
      <S.Logo src={images.logoBlackHorizontal} />
      <S.BigMessage>{content[type].big}</S.BigMessage>
      <S.Title>{content[type].title}</S.Title>
      <S.Message>{content[type].message}</S.Message>
      <S.NavigationButton>
        <Link to="/">{t('goToWebsiteHome')}</Link>
      </S.NavigationButton>
      <S.BeatDecoration inverted />
    </S.Container>
  );
}

NotFound.propTypes = {
  type: PropTypes.oneOf(['not-found', 'uncaught']),
};

NotFound.defaultProps = {
  type: 'not-found',
};
